import { CancelQuoteAction } from 'routes/essential-workspace/components/quote-panel/quote/quote-actions/cancel';
import { ExpiredQuoteActions } from 'routes/essential-workspace/components/quote-panel/quote/quote-actions/expired';
import { PriceQuoteAction } from 'routes/essential-workspace/components/quote-panel/quote/quote-actions/price';
import { PricedQuoteActions } from 'routes/essential-workspace/components/quote-panel/quote/quote-actions/priced';
import { RejectedQuoteActions } from 'routes/essential-workspace/components/quote-panel/quote/quote-actions/rejected';
import { useQuote } from 'routes/essential-workspace/hooks/use-quote';

export function QuoteActions() {
  const { status } = useQuote();
  switch (status) {
    case 'not-ready':
      return (
        <PriceQuoteAction purpose="outline" labelTranslationKey="sidePanel.actions.indicativeQuote" className="w-100" />
      );
    case 'ready':
      return (
        <PriceQuoteAction purpose="primary" labelTranslationKey="sidePanel.actions.indicativeQuote" className="w-100" />
      );
    case 'price-in-progress':
      return <CancelQuoteAction className="w-100" />;
    case 'price-expired':
      return <ExpiredQuoteActions />;
    case 'priced':
      return <PricedQuoteActions />;
    case 'price-rejected':
      return <RejectedQuoteActions />;
    default:
      return null;
  }
}
